import { t } from "@/i18n-js/instance";
import {
  FONT_FAMILY_OPTIONS,
  FONT_WEIGHT_OPTIONS as SITE_BUILDER_FONT_WEIGHT_OPTIONS,
} from "@circle-react-shared/BuilderUI/ThemeConfiguration/SiteStyles/Tokens/Text/TextStyles/constants";

export const EMAIL_FONT_FAMILY_OPTIONS = FONT_FAMILY_OPTIONS;

export const EMAIL_TEXT_FONT_WEIGHT_OPTIONS = [
  {
    label: t("builder_ui.prop_type.styles.font_weight_types.thin"),
    value: "100",
  },
  {
    label: t("builder_ui.prop_type.styles.font_weight_types.light"),
    value: "300",
  },
  {
    label: t("builder_ui.prop_type.styles.font_weight_types.normal"),
    value: "400",
  },
  {
    label: t("builder_ui.prop_type.styles.font_weight_types.medium"),
    value: "500",
  },
  {
    label: t("builder_ui.prop_type.styles.font_weight_types.semibold"),
    value: "600",
  },
  {
    label: t("builder_ui.prop_type.styles.font_weight_types.bold"),
    value: "700",
  },
  {
    label: t("builder_ui.prop_type.styles.font_weight_types.extra_bold"),
    value: "800",
  },
  {
    label: t("builder_ui.prop_type.styles.font_weight_types.black"),
    value: "900",
  },
];

export const EMAIL_BUTTON_FONT_WEIGHT_OPTIONS =
  SITE_BUILDER_FONT_WEIGHT_OPTIONS;

export const FONT_STYLE_OPTIONS = [
  {
    label: t("builder_ui.prop_type.styles.font_style_types.normal"),
    value: "normal",
  },
  {
    label: t("builder_ui.prop_type.styles.font_style_types.italic"),
    value: "italic",
  },
  {
    label: t("builder_ui.prop_type.styles.font_style_types.oblique"),
    value: "oblique",
  },
];

export const TEXT_DECORATION_OPTIONS = [
  {
    label: t("builder_ui.prop_type.styles.text_decoration_types.none"),
    value: "none",
  },
  {
    label: t("builder_ui.prop_type.styles.text_decoration_types.underline"),
    value: "underline",
  },
  {
    label: t("builder_ui.prop_type.styles.text_decoration_types.overline"),
    value: "overline",
  },
  {
    label: t("builder_ui.prop_type.styles.text_decoration_types.line_through"),
    value: "line-through",
  },
];

export const TEXT_TRANSFORM_OPTIONS = [
  {
    label: t("builder_ui.prop_type.styles.text_transform_types.none"),
    value: "none",
  },
  {
    label: t("builder_ui.prop_type.styles.text_transform_types.uppercase"),
    value: "uppercase",
  },
  {
    label: t("builder_ui.prop_type.styles.text_transform_types.lowercase"),
    value: "lowercase",
  },
  {
    label: t("builder_ui.prop_type.styles.text_transform_types.capitalize"),
    value: "capitalize",
  },
];

interface TextAlignOption {
  icon:
    | "20-builder-ui-style-text-align-left"
    | "20-builder-ui-style-text-align-center"
    | "20-builder-ui-style-text-align-right"
    | "20-builder-ui-style-text-align-justify";
  type: "left" | "center" | "right" | "justify";
}

export const TEXT_ALIGN_OPTIONS: TextAlignOption[] = [
  {
    type: "left",
    icon: "20-builder-ui-style-text-align-left",
  },
  {
    type: "center",
    icon: "20-builder-ui-style-text-align-center",
  },
  {
    type: "right",
    icon: "20-builder-ui-style-text-align-right",
  },
  {
    type: "justify",
    icon: "20-builder-ui-style-text-align-justify",
  },
];
